export interface RankingOption {
  label: string;
  value: string;
  [key: string]: any;
}

/**
 * Ranks and filters options based on search string:
 * 1. Starts-with matches first
 * 2. Contains matches second
 * Maintains original order within each group.
 */
export function rankOptions<T extends RankingOption | string>(
  options: T[],
  search: string,
  limit?: number
): T[] {
  const s = search.toLowerCase().trim();
  if (!s) {
    return limit ? options.slice(0, limit) : options;
  }

  const startsWith: T[] = [];
  const contains: T[] = [];

  options.forEach((option) => {
    const label = (
      typeof option === "string" ? option : option.label || option.value
    ).toLowerCase();
    if (label.startsWith(s)) {
      startsWith.push(option);
    } else if (label.includes(s)) {
      contains.push(option);
    }
  });

  const result = [...startsWith, ...contains];
  return limit ? result.slice(0, limit) : result;
}
